var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexibleRepayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 8,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF8040"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFCDB3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30521,
    y: 17.4286,
    width: 5.19481,
    height: 5.19481,
    rx: 1,
    fill: "#231F20"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.61688,
    y: 17.4286,
    width: 5.09091,
    height: 5.09091,
    rx: 1,
    fill: "#FF8040"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.74673,
    y: 17.4286,
    width: 5.19481,
    height: 5.19481,
    rx: 1,
    fill: "#231F20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0584,
    y: 17.4286,
    width: 5.09091,
    height: 5.09091,
    rx: 1,
    fill: "#FF8040"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1883,
    y: 17.4286,
    width: 5.19481,
    height: 5.19481,
    rx: 1,
    fill: "#231F20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.4286,
    width: 5.09091,
    height: 5.09091,
    rx: 1,
    fill: "#FF8040"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30521,
    y: 23.6624,
    width: 5.19481,
    height: 5.19481,
    rx: 1,
    fill: "#231F20"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 3.61688,
    y: 23.6624,
    width: 5.09091,
    height: 5.09091,
    rx: 1,
    fill: "#FF8040"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.74673,
    y: 23.6624,
    width: 5.19481,
    height: 5.19481,
    rx: 1,
    fill: "#231F20"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0584,
    y: 23.6624,
    width: 5.09091,
    height: 5.09091,
    rx: 1,
    fill: "#FF8040"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1883,
    y: 23.6624,
    width: 5.19481,
    height: 5.19481,
    rx: 1,
    fill: "#231F20"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 23.6624,
    width: 5.09091,
    height: 5.09091,
    rx: 1,
    fill: "#FF8040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15C0.5 12.1911 0.5 10.7866 1.17412 9.77772C1.46596 9.34096 1.84096 8.96596 2.27772 8.67412C3.28661 8 4.69108 8 7.5 8H17.5C20.3089 8 21.7134 8 22.7223 8.67412C23.159 8.96596 23.534 9.34096 23.8259 9.77772C24.5 10.7866 24.5 12.1911 24.5 15V15H0.5V15Z",
    fill: "#FF8040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83795 6H6.16209C5.79643 6 5.5 6.32416 5.5 6.724V10.2761C5.5 10.6759 5.79643 11 6.16209 11H7.83795C8.2036 11 8.5 10.6759 8.5 10.2761V6.724C8.5 6.32416 8.2036 6 7.83795 6Z",
    fill: "#FFE8DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8379 6H17.1621C16.7964 6 16.5 6.32416 16.5 6.724V10.2761C16.5 10.6759 16.7964 11 17.1621 11H18.8379C19.2036 11 19.5 10.6759 19.5 10.2761V6.724C19.5 6.32416 19.2036 6 18.8379 6Z",
    fill: "#FFE8DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3492_14911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1222 35L34.7857 34.9405L34.7479 23.1428L16.0844 23.2023L16.1222 35Z",
    fill: "#FF8040"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.871 25.217L30.9719 25.1846C30.9719 26.3136 31.8902 27.2265 33.0246 27.2211L33.0354 30.8836C31.9064 30.8836 30.9935 31.8019 30.9989 32.9363L19.898 32.9687C19.898 31.8397 18.9797 30.9268 17.8453 30.9322L17.8345 27.2697C18.9635 27.2697 19.8764 26.3514 19.871 25.217Z",
    fill: "#FFCDB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3571 26.6952H27.513M23.3571 28.0713H27.513M24.4387 26.6952C24.4387 26.6952 26.0153 26.6952 26.1323 28.0714C26.2555 29.5193 24.3352 29.4261 23.5013 29.3784L26.2752 31.89",
    stroke: "#231F20",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6228 22H30.3772C30.3772 20.4146 29.0907 19.1228 27.5 19.1228V18.8772C29.0854 18.8772 30.3772 17.5907 30.3772 16H30.6228C30.6228 17.5854 31.9093 18.8772 33.5 18.8772V19.1228C31.9146 19.1228 30.6228 20.4093 30.6228 22Z",
    fill: "#FF5200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29C38.6046 29 39.5 28.1046 39.5 27C39.5 25.8954 38.6046 25 37.5 25C36.3954 25 35.5 25.8954 35.5 27C35.5 28.1046 36.3954 29 37.5 29Z",
    fill: "#FF5200"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3492_14911",
    x: 15.0844,
    y: 23.1428,
    width: 19.7013,
    height: 12.1571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.912729 0 0 0 0 0.714512 0 0 0 0 0.156738 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3492_14911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3492_14911",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleRepayment);
export default __webpack_public_path__ + "static/media/flexible_repayment.f38101984eac36049a347ca789a3289d.svg";
export { ForwardRef as ReactComponent };